import {
    adapts,
    AzureBlobFSStoreReadSettingsAdapter
} from 'app/model/adapters/activities/copysource/store-read-settings/azure-blob-fs-store-read-settings.adapter';
import { AdapterRegistry, Metamodel } from 'shell-models-lib';
import { SapDatasphereForAzureDataLakeStorageGen2ReadSettings } from 'app/model/pipeline/copysource/store-read-settings/sap-datasphere-for-azure-data-lake-storage-gen2-read-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapDatasphereForAzureDataLakeStorageGen2ReadSettings),
    asynchronous: true,
    adapts
})
export class SapDatasphereForAzureDataLakeStorageGen2ReadSettingsAdapter extends AzureBlobFSStoreReadSettingsAdapter {}
